import React, { useEffect, useState } from 'react'
import { Wrapper } from './style'
import { ConfigProvider, message, Pagination, Table } from 'antd';
import SpApi from './lib/spApi'
import AmazonAdvertising from './lib/amazonAdvertising'
import { Link, useSearchParams } from 'react-router-dom';
import { MakeApiCall } from '../../../../apis';

function MarketplaceCredentials({userData}) {
  const [searchParams, setSearchParams] = useSearchParams();

  // Default to spApi if tab is not present in URL
  const tabFromUrl = searchParams.get("tab") || "spApi";
  const [activeTab, setActiveTab] = useState(tabFromUrl);

  const [totalPage, setTotalPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [spApiList, setSpApiList] = useState([]);
  const [advertisingList, setAdvertisingList] = useState([]);

  const fetchUserCredentials = async () => {
    setLoading(true);
    try {
      const response = await MakeApiCall(
          'user-credentials',
          'get',
          null,
          true,
          {},
          userData?.token
      );

      if (response?.status) {
        const records = response?.data?.records || {};
        setTotalPage(response?.data?.pagination?.totalCount || 0);
        setPage(response?.data?.pagination?.page || 1);
        setSpApiList(records['SP-API'] || []);
        setAdvertisingList(records['Advertising-API'] || []);
      } else {
        message.warning(response?.message);
        setSpApiList([]);
        setAdvertisingList([]);
      }
    } catch (error) {
      message.error('Error fetching credentials.');
      setSpApiList([]);
      setAdvertisingList([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUserCredentials();
  }, [page, pageSize]);

  useEffect(() => {
    setActiveTab(tabFromUrl);
  }, [tabFromUrl]);

  const handleTabChange = (tabKey) => {
    setActiveTab(tabKey);
    setSearchParams({ tab: tabKey });
  };

  return (
      <Wrapper>
        <div class="mb-10 mx-n9 px-10 py-5 bg-white filter">
          <div class="position-relative ">
            <ul class="nav nav-tabs nav-line-tabs nav-stretch fs-6 d-inline-flex">
              <li class="nav-item">
                <Link
                    class={`nav-link ${activeTab === 'spApi' ? 'active' : ''}`}
                    onClick={() => handleTabChange('spApi')}
                >
                  Amazon SP API
                </Link>
              </li>
              <li class="nav-item">
                <Link
                    class={`nav-link ${activeTab === 'advertising' ? 'active' : ''}`}
                    onClick={() => handleTabChange('advertising')}
                >
                  Amazon Advertising
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {activeTab === 'spApi' && <SpApi list={spApiList} loading={loading} userData={userData}/>}
        {activeTab === 'advertising' && <AmazonAdvertising list={advertisingList} loading={loading}/>}
      </Wrapper>
  )
}

export default MarketplaceCredentials